import {JsonProperty} from '@hyperloris/tyson';
import {DateTime} from 'luxon';

export class Contract {

  constructor() {
  }

  @JsonProperty()
  $type: string| undefined;

  @JsonProperty()
  id: string = "";
  @JsonProperty()
  code: string | undefined;
  @JsonProperty()
  exchangeCode: string | undefined;
  @JsonProperty()
  currency: string | undefined;
  @JsonProperty()
  description: string | undefined;
  @JsonProperty()
  pricePrecision: number;
  @JsonProperty()
  tickValue: number;
  @JsonProperty()
  contractValue: number;
  @JsonProperty()
  version: string | undefined;
  @JsonProperty()
  modificationDate: DateTime = DateTime.now();
  @JsonProperty()
  contractUnit: Contract.ContractUnit | Contract.ContractUnit.CONTRACT_UNITS_BBL;
  @JsonProperty()
  contractSize: number;
  @JsonProperty()
  assetClass: string | undefined;

  @JsonProperty()
  type: Contract.ContractType;

  @JsonProperty()
  underlyingCode: string | undefined;
  @JsonProperty()
  schedule: Contract.SeriesSchedule;
  @JsonProperty()
  strikePrecision: number;
  @JsonProperty()
  optionType: Contract.OptionType;

}

export module Contract {
  export enum ContractUnit {
    CONTRACT_UNITS_LOTS = 'Lots',
    CONTRACT_UNITS_BBL = 'bbl',
    CONTRACT_UNITS_MT = 'mt'
  }
  export enum SeriesSchedule {
    STRIP='STRIP',
    QUARTERLY='QUARTERLY',
    MONTHLY='MONTHLY',
    WEEKLY='WEEKLY',
    DAILY='DAILY'
  }
  export enum OptionType {
    AMERICAN='AMERICAN',
    EUROPEAN='EUROPEAN',
    ASIAN='ASIAN'
  }
  export enum ContractType {
    FUTURE='FUTURE',
    OPTION='OPTION',
    STOCK='STOCK'
  }
}
